const Footer: React.FC = () => {
    return (
      <footer className="py-6 bg-gray-800 text-white text-center">
        <p>&copy; 2024 CryptoExchange. All rights reserved.</p>
      </footer>
    );
  }
  
  export default Footer;
  